<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Resultados de exames"
    >
        <rkm-area
            background-color="primary"
            no-margin-top
            title="Histórico de resultados de exames laboratoriais"
            type="box"
        >
            <rkm-list
                :items="data.form.resultadosExames.laboratoriais"
                hide-filters
                hide-pagination
            >
                <template v-slot="{item}">
                    <rkm-row>
                        <rkm-col cols="4">
                            <strong>Exame</strong><br />{{ item.exame }}
                        </rkm-col>

                        <rkm-col cols="4">
                            <strong>Data</strong><br />{{ item.data }}
                        </rkm-col>

                        <rkm-col cols="4">
                            <strong>Possui resultado</strong><br />{{ item.possuiResultado ? 'Sim' : 'Não' }}
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-list>
        </rkm-area>

        <rkm-area
            background-color="primary"
            title="Histórico de resultados de exames de imagem"
            type="box"
        >
            <rkm-list
                :items="data.form.resultadosExames.imagens"
                hide-filters
                hide-pagination
            >
                <template v-slot="{item}">
                    <rkm-row>
                        <rkm-col cols="4">
                            <strong>Exame</strong><br />{{ item.exame }}
                        </rkm-col>

                        <rkm-col cols="4">
                            <strong>Data</strong><br />{{ item.data }}
                        </rkm-col>

                        <rkm-col cols="4">
                            <strong>Possui resultado</strong><br />{{ item.possuiResultado ? 'Sim' : 'Não' }}
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-list>
        </rkm-area>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>
